import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes, mixins } from "@similarweb/styles";

import {
    APPS_HEADER_PADDING,
    APPS_HEADER_TITLE_HEIGHT,
} from "app/pages/sales-intelligence/pages/find-apps/containers/styles";

export const StyledAppsTitleIcon = styled(SWReactIcons)`
    & svg path {
        fill: ${colorsPalettes.carbon["500"]};
        fill-opacity: 1;
    }
`;

export const StyledAppsTitleText = styled.h2`
    ${mixins.setFontVariant("h4", colorsPalettes.carbon["500"])};
    line-height: ${APPS_HEADER_TITLE_HEIGHT}px;
    margin: 0;
`;

export const StyledAppsHeaderWrap = styled.div`
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding: ${APPS_HEADER_PADDING}px 8px ${APPS_HEADER_PADDING}px 32px;
    background-color: ${colorsPalettes.carbon["0"]};
`;

export const StyledAppsTitleWrap = styled.div`
    align-items: center;
    display: flex;
    gap: 8px;
`;
